import React from "react";
import Routes from "./routes";
const App = () => <Routes />;
export default App;
